<template>
  <!-- 创建/编辑试卷 -->
    <div class="board">
        <div v-hasPermi="['questionBank:testPaper:update']" class="h100p">
            <div class="title">
                <span>
                    <el-button type="text" icon="el-icon-arrow-left"
                               @click="$router.push('/testPaper')">
                        {{ testPaperEditTextConfig.back }}
                    </el-button>
                    <el-divider direction="vertical"></el-divider>
                    <span class="name">{{ testPaperEditTextConfig.title }} </span>
                </span>
                <span style="font-size:14px;line-height:34px;color:rgb(165 165 165)">
                    <i v-if="editSave" class="el-icon-loading"></i>
                    {{ testPaperEditTextConfig.autoSave.name }}
                    <el-button v-show="recovery" @click="clickRecovery" size="mini" type="primary"
                               style="margin-left:10px">{{ testPaperEditTextConfig.recovery.name }}</el-button>
                </span>
            </div>
            <div class="questionCon" :key="loadKey" v-loading="loading" element-loading-text="加载中"
                 element-loading-spinner="el-icon-loading">
                <div class="left">
                    <el-form :model="form" :rules="rules" ref="form">
                        <el-form-item :label="formTextConfig.name" label-width="90px" prop="name">
                            <el-input v-model="form.name" maxlength="100" show-word-limit clearable
                                      :placeholder="formTextConfig.nameTip"></el-input>
                        </el-form-item>
                    </el-form>
                    <el-card class="box-card" shadow="hover">
                        <el-form>
                            <el-form-item label="竞赛说明" label-width="90px">
                                <quill-editor ref="introductionEditor" class="editor" :value.sync="form.introduction">
                                </quill-editor>
                            </el-form-item>
                        </el-form>
                    </el-card>
                    <el-card class="box-card" :id="'module'+index" shadow="hover" v-for="(item,index) in question"
                             :key="index+key">
                        <el-button-group class="moduleButtonGroup">
                            <el-button
                                    @click="questionIndex=index,moduleOldName=item.name,creatModuleDialogVisible=true"
                                    plain type="primary">{{ modelButtonTextConfig.rename.name }}
                            </el-button>
                            <el-button @click="swapArray(question, index-1, index)" :disabled="index==0" plain
                                       type="primary">{{ modelButtonTextConfig.moveUp.name }}
                            </el-button>
                            <el-button @click="swapArray(question, index, index+1)" :disabled="index==question.length-1"
                                       plain type="primary">{{ modelButtonTextConfig.moveDown.name }}
                            </el-button>
                            <el-button @click="deleteQuestion(index)" plain type="danger">
                                {{ modelButtonTextConfig.remove.name }}
                            </el-button>
                        </el-button-group>
                        <div slot="header" class="unClearfix">
                            <span>{{ item.name }}</span>
                            <span style="white-space:pre">{{
                                questionTextConfig.tip.signMix(item.question_num, item.total_score)
                                }}</span>
                        </div>
                        <div class="questionModle" :id="'module'+index+'question'+i" v-for="(e,i) in item.question_list"
                             :key="i+key">
                            <el-button-group class="questionButtonGroup">
                                <el-button @click="setAnswerWayDialog(index,i,e.review_mode)" plain type="primary"
                                           v-if="item.question_type === 'subjectivity'">
                                    {{ questionButtonTextConfig.setAnswerWay.name }}
                                </el-button>
                                <el-button @click="setScoreDialog(index,i)" plain type="primary">{{
                                    questionButtonTextConfig.setScore.name
                                    }}
                                </el-button>
                                <el-button
                                        @click="questionIndex=index,ModuleType={type:item.question_type,list:[i],index},moduleDialogVisible=true"
                                        plain type="primary">{{ questionButtonTextConfig.changeModel.name }}
                                </el-button>
                                <el-button @click="swapArray(item.question_list, i-1, i)" :disabled="i==0" plain
                                           type="primary">{{ questionButtonTextConfig.moveUp.name }}
                                </el-button>
                                <el-button @click="swapArray(item.question_list, i, i+1)"
                                           :disabled="i==item.question_list.length-1" plain type="primary">{{
                                    questionButtonTextConfig.moveDown.name
                                    }}
                                </el-button>
                                <el-button @click="deleteQuestion(index,i)" plain type="danger">{{
                                    questionButtonTextConfig.remove.name
                                    }}
                                </el-button>
                            </el-button-group>
                            <span>{{ i + 1 }}.</span>
                            <p v-html="e.newStem" class="ql-editor"></p>
                            <div v-if="e.crosshead">
                                <div v-for="(n,l) in e.crosshead" :key="l">
                                    <span class="questionIndex">（{{ l + 1 }}）</span>
                                    <p v-html="n.newStem" class="ql-editor"
                                       style="display:inline-block;max-width:calc(100% - 45px)"></p>
                                </div>
                            </div>
                            <p style="margin:10px 0" v-if="e.attachment.stem">
                                <el-tag size="medium"><a
                                        :href="config_env.BASE_URL+getDownloadAddress(e.attachment.stem.file_path,e.attachment.stem.file_name)"
                                        target="_blank"><i class="el-icon-download"></i>
                                    {{ questionTextConfig.attachment }}
                                    {{ e.attachment.stem.file_name }}</a></el-tag>
                            </p>
                            <el-button v-if="item.question_type == 'subjectivity' && e.training_id" @click="seeShare(e)"
                                       type="primary" icon="el-icon-monitor" size="mini">
                                {{ e.training_label }}
                            </el-button>
                            <div v-if="item.question_type != 'fill' && item.question_type != 'subjectivity'"
                                 style="margin-top:6px">
                                <p v-for="(f,j) in e.choices" :key="j" :label="j"
                                   style="display:block;line-height:26px;"><i>{{ letter[j] }} .&nbsp;&nbsp;</i><span
                                        v-html="f" class="ql-editor" style="display:inline-flex"></span></p>
                            </div>
                            <p>
                                <el-button v-if="item.question_type === 'subjectivity'" type="text"
                                           @click="setAnswerWayDialog(index,i,e.review_mode)">
                                    {{ questionButtonTextConfig.setAnswerWay.name }}：{{
                                    getAnswerWayLabel(e.submit_mode)
                                    }}
                                </el-button>
                            </p>
                        </div>
                        <p class="info" style="text-align:center">
                            {{ !item.question_num ? questionTextConfig.noQuestion : '' }}
                            <el-button type="primary" @click="addQuestion(item,index)">
                                {{ questionButtonTextConfig.add.name }}{{
                                item.question_type | formatType(typeOptions)
                                }}
                            </el-button>
                        </p>
                    </el-card>
                    <p class="info" v-if="!question.length" style="text-align:center">{{ modelTextConfig.noModel }}
                        <el-button @click="creatModuleDialogVisible = true" type="primary">
                            {{ modelButtonTextConfig.add.name }}
                        </el-button>
                    </p>
                </div>
                <div class="right">
                    <el-card class="box-card" shadow="hover">
                        <div slot="header" class="clearfix">
                            <span>{{ cardTextConfig.name }}</span>
                            <span style="white-space:pre">{{
                                cardTextConfig.tip.signMix(questionNum, questionScore)
                                }}</span>
                        </div>
                        <div class="questionButtons">
                            <p v-if="!question.length" class="info">{{ cardTextConfig.nullTip }}</p>
                            <div v-for="(item,index) in question" :key="index" style="margin-bottom:6px">
                                <a :href="'#module'+index" style="padding-bottom:5px">{{ item.name }}</a>
                                <p v-if="!item.question_num" class="info">{{ cardTextConfig.nullQuestion }}</p>
                                <div v-else>
                                    <span v-for="(e,i) in item.question_list" :key="i+key" class="questionButton">
                                        <a><el-button
                                                :class="['questionA',{'questionCheck':operation&&e.ischeck?true:false}]"
                                                @click="clickQuestion(index,i)" style="width:100%">
                                            <span class="check" v-show="operation&&e.ischeck"><i
                                                    class="el-icon-check"></i></span><span
                                                class="number">{{ i + 1 }}</span>
                                        </el-button></a>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <p v-show="!operation">
                            <el-button @click="setOperation" :disabled="questionNum == 0" type="primary" plain
                                       style="width:100%;margin-top:10px;display:block">
                                {{ cardButtonTextConfig.batch.name }}
                            </el-button>
                        </p>
                        <p v-show="!operation">
                            <el-button @click="creatModuleDialogVisible = true" type="primary" plain
                                       style="width:100%;margin-top:10px;display:block">{{
                                cardButtonTextConfig.add.name
                                }}
                            </el-button>
                        </p>
                        <div v-show="operation">
                            <el-row style="line-height:44px">
                                <el-col :span="6">
                                    <el-button type="text" @click="selectAll">{{
                                        select ? cardButtonTextConfig.selectAll.cancel : ''
                                        }}{{ cardButtonTextConfig.selectAll.name }}
                                    </el-button>
                                </el-col>
                                <el-col :span="6">
                                    <el-button type="text" @click="setAnswerWayDialog()">
                                        {{ cardButtonTextConfig.setAnswerWay.name }}
                                    </el-button>
                                </el-col>
                                <el-col :span="6">
                                    <el-button type="text" @click="setScoreDialog()">
                                        {{ cardButtonTextConfig.setScore.name }}
                                    </el-button>
                                </el-col>
                                <el-col :span="6">
                                    <el-button type="text" @click="batchDelete">{{
                                        cardButtonTextConfig.remove.name
                                        }}
                                    </el-button>
                                </el-col>
                            </el-row>
                            <el-button @click="operation = !operation" type="primary" plain
                                       style="margin-top:8px;width:100%">{{ cardButtonTextConfig.complete.name }}
                            </el-button>
                        </div>
                    </el-card>
                    <el-button @click="completePaper" :disabled="!questionNum" type="primary" style="width:100%">
                        {{ cardButtonTextConfig.completePaper.name }}
                    </el-button>
                </div>
            </div>
            <!-- 弹窗：答题方式 -->
            <el-dialog
                    :title="(answerWayIndex||answerWayIndex===0)?cardButtonTextConfig.setAnswerWay.title:cardButtonTextConfig.setAnswerWay.batchTitle"
                    :visible.sync="answerWayDialogVisible" width="420px" :close-on-click-modal="false"
                    :close-on-press-escape="false">
                <el-form :model="scoreForm" :rules="rules" ref="scoreForm" label-width="80px">
                    <el-form-item :label="cardButtonTextConfig.setAnswerWay.form.answerWay">
                        <el-checkbox-group v-model="submit_mode" :disabled="answerWayDisable">
                            <el-checkbox v-for="item in submitModeOptions" :label="item.dict_value" :key="item.id">{{ item.dict_label }}</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <p class="info">{{ cardButtonTextConfig.setAnswerWay.form.tip }}</p>
                    <p class="info" v-if="(!answerWayIndex && answerWayIndex !== 0)">
                        {{ cardButtonTextConfig.setAnswerWay.form.tip2 }}</p>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="answerWayDialogVisible=false">{{
                        cardButtonTextConfig.setAnswerWay.cancel
                        }}</el-button>
                    <el-button type="primary" @click="submitAnswerWayForm()">确定</el-button>
                </span>
            </el-dialog>
            <!-- 弹窗：(批量)设置分值 -->
            <el-dialog :title="scoreData?cardSetScoreTextConfig.title:cardSetScoreTextConfig.batchTitle"
                       :visible.sync="scoreDialogVisible" width="420px"
                       :close-on-click-modal="false" :close-on-press-escape="false">
                <el-form :model="scoreForm" :rules="rules" ref="scoreForm" label-width="80px">
                    <el-form-item v-if="!scoreForm.crosshead || scoreForm.crosshead && scoreForm.crosshead == 0" :label="cardSetScoreTextConfig.form.score"
                                  prop="score">
                        <el-input-number v-model="scoreForm.score" :min="0" :step="0.1" step-strictly></el-input-number>
                    </el-form-item>
                    <div v-else>
                        <el-form-item v-for="(s,j) in scoreForm.crosshead" :key="j+key"
                                      :label="cardSetScoreTextConfig.form.crosshead.signMix(j + 1)"
                                      label-width="120px" prop="score">
                            <el-input-number type="number" v-model="scoreForm.crosshead[j]" @change="key+=2" :min="0"
                                             :step="0.1" step-strictly></el-input-number>
                        </el-form-item>
                    </div>
                    <p v-if="error" v-html="errorStr" style="color:#F56C6C"></p>
                    <p class="info">
                        {{
                        cardButtonTextConfig.setScore.form.tip
                        }}<br/>{{ scoreData ? '' : cardSetScoreTextConfig.form.tip2 }}</p>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="scoreDialogVisible=false">{{ cardSetScoreTextConfig.cancel }}</el-button>
                    <el-button type="primary" @click="submitScoreForm()">{{ cardSetScoreTextConfig.ok }}</el-button>
                </span>
            </el-dialog>
            <!-- 弹窗：变更模块 -->
            <el-dialog :title="changeModelTextConfig.title" :visible.sync="moduleDialogVisible" width="420px" :close-on-click-modal="false"
                       :close-on-press-escape="false">
                <el-form label-width="40px">
                    <el-form-item :label="changeModelTextConfig.form.type" prop="type">
                        <el-select v-model="questionIndex" :placeholder="changeModelTextConfig.form.typeTip">
                            <el-option v-for="(item,index) in question" :disabled="ModuleType.type!=item.question_type"
                                       :key="index" :label="item.name" :value="index"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="moduleDialogVisible=false">{{ changeModelTextConfig.cancel }}</el-button>
                    <el-button type="primary" @click="changeModule(questionIndex)">{{ changeModelTextConfig.ok }}</el-button>
                </span>
            </el-dialog>
            <creat-paper :creatModuleShow.sync="creatModuleDialogVisible"
                         @creatModuleDialogClose="creatModuleDialogClose" :moduleOldName="moduleOldName"
                         :addQuestionShow.sync="addQuestionDialogVisible"
                         @addQuestionDialogClose="addQuestionDialogClose" :ModuleType="ModuleType"
                         :disableData="disableData"></creat-paper>
        </div>
    </div>
</template>

<script>
import creatPaper from './dialog/creatPaper.vue'
import {getDownloadAddress} from '@/utils/common.js'
import quillEditor from '@/components/editor/index.vue'
import {getDict} from "@/api/dict";

export default {
    components: {
        creatPaper,
        quillEditor
    },
    data() {
        return {
            loading: true,
            editSave: false,
            recovery: false,
            form: {
                id: null,
                name: '',
                introduction: '',
                metas: null
            },
            operation: false,
            select: false,
            checkNum: 0,
            scoreDialogVisible: false,
            questionNum: 0,
            questionScore: 0,
            letter: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
            question: [{
                name: '单选题',
                type: 'single_choice',
                score: 0,
                question_list: []
            }, {
                name: '多选题',
                type: 'choice',
                score: 0,
                question_list: []
            }],
            answerWays: [{
                label: '文本+附件',
                value: 'full'
            }, {
                label: '文本',
                value: 'text'
            }, {
                label: '附件',
                value: 'attachment'
            }, {
                label: '无',
                value: 'none'
            }],
            creatModuleDialogVisible: false,
            typeOptions: [],
            addQuestionDialogVisible: false,
            ModuleType: {type: null, list: [], index: null},
            disableData: [],
            key: 0,
            scoreForm: {
                score: 2
            },
            rules: {
                score: [
                    {
                        required: true,
                        message: this.$store.state.global.textConfig.backend.testPaperEdit.card.button.setScore.form.scoreRule,
                        trigger: 'change'
                    },
                    {
                        validator: function (rule, value, callback) {
                            if (value === 0) {
                                callback(new Error(this.$store.state.global.textConfig.backend.testPaperEdit.card.button.setScore.form.scoreRule2));
                            } else {
                                callback();
                            }
                        },
                        trigger: "change"
                    }
                ],
                name: [
                    {
                        required: true,
                        message: this.$store.state.global.textConfig.backend.testPaperEdit.form.nameRule,
                        trigger: 'change'
                    },
                    {
                        validator: function (rule, value, callback) {
                            if (/^[\u4E00-\u9FA5A-Za-z0-9()（）]+$/g.test(value) == false && value) {
                                callback(new Error("仅支持输入中英文、数字、圆括号"));
                            } else {
                                callback();
                            }
                        },
                        trigger: "change"
                    }
                ],
            },
            scoreData: null,
            error: false,
            errorStr: '',
            questionIndex: null,
            moduleOldName: null,
            moduleDialogVisible: false,
            temporaryPaper: null,
            loadKey: 0,
            answerWayDialogVisible: false,
            answerWayIndex: null,
            answerWay: null,
            submitModeOptions: [],
            submit_mode:[],
            answerWayDisable: false,
        }
    },
    computed: {
        testPaperEditTextConfig() {
            return this.$store.state.global.textConfig.backend.testPaperEdit
        },
        formTextConfig() {
            return this.testPaperEditTextConfig.form
        },
        modelTextConfig() {
            return this.testPaperEditTextConfig.model
        },
        modelButtonTextConfig() {
            return this.modelTextConfig.button
        },
        questionTextConfig() {
            return this.testPaperEditTextConfig.question
        },
        questionButtonTextConfig() {
            return this.questionTextConfig.button
        },
        changeModelTextConfig() {
            return this.questionButtonTextConfig.changeModel
        },
        cardTextConfig() {
            return this.testPaperEditTextConfig.card
        },
        cardButtonTextConfig() {
            return this.cardTextConfig.button
        },
        cardSetScoreTextConfig() {
            return this.cardButtonTextConfig.setScore
        },
    },
    watch: {
        question() {
            this.recovery = false
        }
    },
    methods: {
        getDownloadAddress,
        seeShare(e) {
            let name = localStorage.getItem("1+XUserIdentity");
            this.$store.dispatch("getTrainingInstanceSrc", e.training_id).then(res => {
                if (res.status == 200) {
                    let routeUrl = this.$router.resolve({
                        path: "/practicalTraining",
                        query: {name, time: null, trainingMirror: e.training_id, questionId: e.id,reviewMode:e.review_mode}
                    });
                    window.open(routeUrl.href, '_blank');
                }
            })
        },
        getAnswerWayLabel(submitModeList) {
            let ret = [];
            submitModeList.forEach(submitMode => {
                let already = this.submitModeOptions.find(item => item.dict_value == submitMode)
                if (already) {
                    ret.push(already.dict_label)
                }
            })
            if (ret.length == 0) {
                return "无"
            } else {
                return ret.join('/')
            }

        },
        swapArray(arr, index1, index2) {
            // 实现上移下移
            arr[index1] = arr.splice(index2, 1, arr[index1])[0];
            this.key += 1
            this.temporaryPaperSave()
            return arr;
        },
        setOperation() {
            this.operation = !this.operation
            this.select = false
            this.checkNum = []
            if (this.operation) {
                this.setQuestionCheck(false)
            }
        },
        clickQuestion(index, i) {
            // 滚动到指定位置
            const parent = document.querySelector('.left');
            const child = document.querySelector(`#module${index}question${i}`);
            parent.scrollTo({top: (child.offsetParent.offsetTop + child.offsetTop - 180), behavior: "smooth"});

            if (this.operation) {
                this.question[index].question_list[i].ischeck = !this.question[index].question_list[i].ischeck
                this.checkNum = 0
                for (let j = 0; j < this.question.length; j++) {
                    const list = this.question[j].question_list;
                    for (let k = 0; k < list.length; k++) {
                        const e = list[k];
                        if (e.ischeck) this.checkNum += 1
                    }
                }
                if (this.checkNum < this.questionNum) {
                    this.select = false
                } else if (this.checkNum == this.questionNum) {
                    this.select = true
                }
                this.key += 1
            }
        },
        selectAll() {
            this.select = !this.select
            this.setQuestionCheck(this.select)
            if (this.select) this.checkNum = this.questionNum
            else this.checkNum = 0
        },
        setQuestionCheck(bool) {
            for (let j = 0; j < this.question.length; j++) {
                const list = this.question[j].question_list;
                for (let k = 0; k < list.length; k++) {
                    list[k].ischeck = bool
                }
            }
        },
        setScoreDialog(index, i) {
            this.scoreForm = {score: 2}
            this.scoreData = null
            if (index || index === 0) {
                this.scoreData = {index, i}
                if (this.question[index].question_list[i].type == 'subjectivity') {
                    let crosshead = this.question[index].question_list[i].crosshead
                    if (crosshead && crosshead.length > 0) {
                        this.scoreForm.crosshead = []
                        for (let j = 0; j < crosshead.length; j++) {
                            this.scoreForm.crosshead.push(crosshead[j].score)
                        }
                    }
                }
                this.scoreDialogVisible = true
                this.scoreForm.score = this.question[index].question_list[i].score
            } else {
                if (this.checkNum > 0) {
                    this.scoreForm.score = 2
                    this.scoreDialogVisible = true
                } else {
                    this.$message({
                        message: this.cardButtonTextConfig.setScore.nullTip,
                        type: 'warning'
                    });
                }
            }
            this.error = false
        },
        setAnswerWayDialog(index, i, review_mode) {
            this.answerWayDisable = false
            if (i || i === 0) {
                this.questionIndex = index
                this.answerWayIndex = i
                this.submit_mode = this.question[index].question_list[i].submit_mode
                this.answerWayDialogVisible = true
                this.answerWayDisable = review_mode === 'script'
            } else {
                if (this.checkNum > 0) {
                    for (let j = 0; j < this.question.length; j++) {
                        const list = this.question[j].question_list;
                        for (let k = 0; k < list.length; k++) {
                            const e = list[k];
                            if (e.ischeck) {
                                if (this.question[j].question_type != 'subjectivity') {
                                    this.answerWayDisable = true
                                    break
                                } else if (e.review_mode && e.review_mode === 'script') {
                                    this.answerWayDisable = true
                                    break
                                }

                            }
                        }
                        if (this.answerWayDisable == true) {
                            break
                        }
                    }
                    this.questionIndex = null
                    this.answerWayIndex = null
                    this.submit_mode = []
                    this.answerWayDialogVisible = true
                } else {
                    this.$message({
                        message: this.cardButtonTextConfig.setAnswerWay.nullTip,
                        type: 'warning'
                    });
                }
            }
        },
        submitAnswerWayForm() {
            if (this.answerWayIndex || this.answerWayIndex === 0) {
                this.question[this.questionIndex].question_list[this.answerWayIndex].submit_mode = this.submit_mode
            } else {
                let len = false
                for (let i = 0; i < this.question.length; i++) {
                    const list = this.question[i].question_list;
                    for (let j = 0; j < list.length; j++) {
                        const e = list[j];
                        if (e.ischeck) {
                            if (e.type === 'subjectivity') {
                                e.submit_mode = this.submit_mode
                            } else {
                                len = true
                            }
                        }
                    }
                }
                if (len) {
                    this.$message({
                        message: this.cardButtonTextConfig.setAnswerWay.error,
                        type: 'warning'
                    });
                }
            }
            setTimeout(() => {
                this.answerWayDialogVisible = false
                this.$message({
                    message: this.cardButtonTextConfig.setAnswerWay.success,
                    type: 'success'
                });
                this.statisticsQuestion()
                this.temporaryPaperSave()
                // this.key += 1
            }, 500)
        },
        batchDelete() {
            let deleteTextConfig = this.cardButtonTextConfig.remove
            if (this.checkNum > 0) {
                let str = deleteTextConfig.message.signMix(this.checkNum)
                this.$confirm(str, deleteTextConfig.title, {
                    confirmButtonText: deleteTextConfig.ok,
                    cancelButtonText: deleteTextConfig.cancel,
                    type: 'warning'
                }).then(() => {
                    for (let i = 0; i < this.question.length; i++) {
                        const list = this.question[i].question_list;
                        for (let j = 0; j < list.length; j++) {
                            const e = list[j];
                            if (e.ischeck) {
                                list.splice(j, 1)
                                j--
                            }
                        }
                    }
                    this.select = false
                    this.$message({
                        type: 'success',
                        message: deleteTextConfig.success
                    });
                    this.statisticsQuestion()
                    this.temporaryPaperSave()
                }).catch(() => {
                });
            } else {
                this.$message({
                    message: deleteTextConfig.error,
                    type: 'warning'
                });
            }
        },
        deleteQuestion(index, i) {
            let deleteTextConfig = this.questionButtonTextConfig.remove
            if (this.question[index].question_list.length) {
                let str = ''
                if (i === 0 || i) str = deleteTextConfig.questionMessage
                else str = deleteTextConfig.modelMessage
                this.$confirm(str, `${i === 0 || i ? deleteTextConfig.questionTitle : deleteTextConfig.modelTitle}`, {
                    confirmButtonText: deleteTextConfig.ok,
                    cancelButtonText: deleteTextConfig.cancel,
                    type: 'warning'
                }).then(() => {
                    if (i === 0 || i) this.question[index].question_list.splice(i, 1)
                    else {
                        this.question.splice(index, 1)
                        this.key += 1
                    }
                    this.$message({
                        type: 'success',
                        message: deleteTextConfig.success
                    });
                    this.statisticsQuestion()
                    this.temporaryPaperSave()
                })
            } else {
                this.question.splice(index, 1)
                this.key += 1
                this.temporaryPaperSave()
            }
        },
        creatModuleDialogClose(data) {
            this.creatModuleDialogVisible = false
            if (this.moduleOldName) {
                const i = this.questionIndex
                if (data) {
                    this.question[i].name = data
                    this.temporaryPaperSave()
                }
                this.moduleOldName = null
            }
        },
        addQuestion(item, index) {
            this.ModuleType = {type: item.question_type, list: item.question_list, index}
            let disableData = []
            for (let i = 0; i < this.question.length; i++) {
                const e = this.question[i];
                if (i != index && e.question_type == item.question_type) {
                    for (let j = 0; j < e.question_list.length; j++) {
                        const id = e.question_list[j].id;
                        if (!e.question_list[j].attachment) {
                            e.question_list[j].attachment = {}
                        }
                        disableData.push(id)
                    }
                }
            }
            this.disableData = disableData
            this.addQuestionDialogVisible = true
        },
        addQuestionDialogClose(data) {
            this.ModuleType = {type: null, list: [], index: null}
            let i = data.index * 1
            this.question[i].question_list = []
            this.question[i].question_list = data.data
            for (let j = 0; j < this.question[i].question_list.length; j++) {
                const e = this.question[i].question_list[j];
                if (!e.attachment) {
                    e.attachment = {}
                }
                if (e.type == 'fill') {
                    e.stem = e.stem.replace(/\[\[(.*?)\]\]/g, '________________')
                }
                let stem = e.stem
                if (stem.indexOf('</p>') != -1) {
                    e.newStem = stem.slice(0, -4) + `<span class="el-tag el-tag--info el-tag--mini scoreTag">${e.score}分</span></p>`
                } else {
                    e.newStem = stem + `<span class="el-tag el-tag--info el-tag--mini scoreTag">${e.score}分</span>`
                }
                if (e.type == 'single_choice' || e.type == 'choice' || e.type == 'uncertain_choice') {
                    // e.choices = JSON.parse(e.choices)
                }
                if (e.type == 'subjectivity') {
                    // e.crosshead=[{stem:'小题',score:2},{stem:'小题',score:3}]
                    if (e.submit_mode) {
                        if (e.submit_mode.includes('text') && e.submit_mode.includes('attachment')) {
                            e.answer_way = 'full'
                        } else if (e.submit_mode.includes('text')) {
                            e.answer_way = 'text'
                        } else if (e.submit_mode.includes('attachment')) {
                            e.answer_way = 'attachment'
                        } else {
                            e.answer_way = 'none'
                        }
                    } else {
                        e.answer_way = 'full'
                    }

                    // e.answer_way = e.answer_way ? e.answer_way : this.answerWays[0].value
                    if (e.crosshead) {
                        for (let l = 0; l < e.crosshead.length; l++) {
                            const f = e.crosshead[l]
                            let str = f.stem
                            if (str.indexOf('</p>') != -1) {
                                f.newStem = str.slice(0, -4) + `<span class="el-tag el-tag--info el-tag--mini scoreTag">${f.score}分</span></p>`
                            } else {
                                f.newStem = str + `<span class="el-tag el-tag--info el-tag--mini scoreTag">${f.score}分</span>`
                            }
                        }
                    }

                }
            }
            setTimeout(() => {
                this.setQuestionCheck(false)
                this.select = false
                this.statisticsQuestion()
                this.disableData = []
                this.temporaryPaperSave()
            }, 200);

        },
        statisticsQuestion() {
            let num = 0, s = 0
            for (let i = 0; i < this.question.length; i++) {
                const list = this.question[i].question_list;
                num += list.length
                let score = 0
                for (let j = 0; j < list.length; j++) {
                    const e = list[j];
                    score += e.score
                }
                this.question[i].question_num = list.length
                this.question[i].total_score = Math.round(score.toFixed(2) * 100) / 100
                s += score
            }
            this.questionNum = num
            this.questionScore = Math.round(s.toFixed(2) * 100) / 100
            if (this.questionNum == 0) {
                this.operation = false
            }

            if (this.operation) {
                this.checkNum = 0
                for (let j = 0; j < this.question.length; j++) {
                    const list = this.question[j].question_list;
                    for (let k = 0; k < list.length; k++) {
                        const e = list[k];
                        if (e.ischeck) this.checkNum += 1
                    }
                }
            }
        },
        submitScoreForm() {
            this.error = false
            this.errorStr = ''
            let close = false
            if (this.scoreData) {
                let index = this.scoreData.index
                let i = this.scoreData.i
                if (this.scoreForm.crosshead) {
                    let isOk = true
                    for (let j = 0; j < this.scoreForm.crosshead.length; j++) {
                        const e = this.scoreForm.crosshead[j];
                        if (e == 0 || e == undefined) {
                            isOk = false
                            this.error = true
                            this.errorStr += e == 0 ? this.cardSetScoreTextConfig.zeroMessage.signMix(j + 1) : this.cardSetScoreTextConfig.nullMessage.signMix(j + 1)
                        }
                    }
                    if (isOk) {
                        let score = 0
                        for (let j = 0; j < this.scoreForm.crosshead.length; j++) {
                            const e = this.scoreForm.crosshead[j];
                            this.question[index].question_list[i].crosshead[j].score = e
                            score += e
                        }
                        this.question[index].question_list[i].score = score
                        close = true
                    }
                } else {
                    if (this.scoreForm.score > 0) {
                        this.question[index].question_list[i].score = this.scoreForm.score
                        close = true
                    }
                }
            } else {
                if (this.scoreForm.score > 0) {
                    let len = false
                    for (let j = 0; j < this.question.length; j++) {
                        const list = this.question[j].question_list;
                        for (let k = 0; k < list.length; k++) {
                            const e = list[k];
                            if (e.ischeck) {
                                if (e.type == 'subjectivity' && e.crosshead) {
                                    if (e.crosshead.length) {
                                        len = true
                                    } else {
                                        e.score = this.scoreForm.score
                                    }
                                } else {
                                    e.score = this.scoreForm.score
                                }
                            }
                        }
                    }
                    close = true
                    if (len) {
                        this.$message({
                            message: this.cardSetScoreTextConfig.error,
                            type: 'warning'
                        });
                    }
                }
            }
            if (close) {
                this.statisticsQuestion()
                for (let m = 0; m < this.question.length; m++) {
                    const list = this.question[m].question_list;
                    for (let n = 0; n < list.length; n++) {
                        const li = list[n];
                        let liScore = this.cardSetScoreTextConfig.scoreTip.signMix(li.score)
                        let stem = li.stem
                        if (stem.indexOf('</p>') != -1) {
                            li.newStem = stem.slice(0, -4) + `<span class="el-tag el-tag--info el-tag--mini scoreTag">${liScore}</span></p>`
                        } else {
                            li.newStem = stem + `<span class="el-tag el-tag--info el-tag--mini scoreTag">${liScore}</span>`
                        }
                        if (this.question[m].question_type == 'subjectivity') {
                            if (li.crosshead) {
                                for (let o = 0; o < li.crosshead.length; o++) {
                                    const f = li.crosshead[o]
                                    let fScore = this.cardSetScoreTextConfig.scoreTip.signMix(f.score)
                                    let str = f.stem
                                    if (str.indexOf('</p>') != -1) {
                                        f.newStem = str.slice(0, -4) + `<span class="el-tag el-tag--info el-tag--mini scoreTag">${fScore}</span></p>`
                                    } else {
                                        f.newStem = str + `<span class="el-tag el-tag--info el-tag--mini scoreTag">${fScore}</span>`
                                    }
                                }
                            }
                        }
                    }
                }
                setTimeout(() => {
                    this.scoreDialogVisible = false
                    this.$message({
                        message: this.cardSetScoreTextConfig.success,
                        type: 'success'
                    });
                    this.statisticsQuestion()
                    this.temporaryPaperSave()
                    this.key += 1
                }, 500);
            }
        },
        changeModule(index) {
            let i = this.ModuleType.index, j = this.ModuleType.list[0]
            if (index != i) {
                let data = this.question[i].question_list[j]
                this.question[index].question_list.push(data)
                this.question[i].question_list.splice(j, 1)
                this.$message({
                    message: this.changeModelTextConfig.success,
                    type: 'success'
                });
                this.statisticsQuestion()
                this.temporaryPaperSave()
                this.key += 1
            }
            this.ModuleType = {type: null, list: [], index: null}
            this.moduleDialogVisible = false
            this.questionIndex = null
        },
        completePaper() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    for (let i = 0; i < this.question.length; i++) {
                        const e = this.question[i];
                        for (let j = 0; j < e.question_list.length; j++) {
                            const f = e.question_list[j];
                            f.metas = {}
                            if (e.question_type == 'subjectivity') {
                                if (f.crosshead) f.metas = {
                                    crosshead: f.crosshead,
                                    training_id: f.training_id,
                                    training_mirror: f.training_mirror,
                                    training_label:f.training_label,
                                    platform_mark:f.platform_mark,
                                    training_bill:f.training_bill,
                                    bank_name: f.bank_name,
                                    bank_id: f.bank_id
                                }
                                f.metas.answer_way = f.submit_mode
                                f.metas.submit_mode = f.submit_mode
                            } else f.metas = {bank_name: f.bank_name, bank_id: f.bank_id}
                        }
                    }
                    this.form.metas = {test_paper_section_list: this.question}
                    this.$store.dispatch("putPaper", this.form).then(res => {
                        if (res.status == 200) {
                            this.$message({
                                message: this.cardButtonTextConfig.completePaper.success,
                                type: 'success'
                            });
                            this.$router.push('/testPaper')
                            this.$route.meta.keepAlive = false
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        clickRecovery() {
            let recoveryTextConfig = this.testPaperEditTextConfig.recovery
            this.$confirm(recoveryTextConfig.message, recoveryTextConfig.title, {
                confirmButtonText: recoveryTextConfig.ok,
                cancelButtonText: recoveryTextConfig.cancel,
                type: 'warning',
                dangerouslyUseHTMLString: true
            }).then(() => {
                this.recovery = false
                this.question = this.temporaryPaper.metas.test_paper_section_list
                this.form.name = this.temporaryPaper.name
                this.temporaryPaper = null
                this.statisticsQuestion()
                this.$message({
                    message: recoveryTextConfig.success,
                    type: 'success'
                });
            }).catch(() => {
                this.recovery = true
            });
        },
        temporaryPaperSave() {
            this.recovery = false
            this.editSave = true
            let form = JSON.parse(JSON.stringify(this.form))
            form.name = this.$route.query.name
            form.metas = {test_paper_section_list: this.question}
            this.$store.dispatch("postExamPaperAutoSave", form).then(res => {
                this.editSave = false
            });
            setTimeout(() => {
            }, 400);
        }
    },
    created() {
        getDict('submit_mode').then(res => {
            this.submitModeOptions = res.data.filter(item => item.dict_value !== 'objective')
        })
        let id = this.$route.query.id
        this.form.id = id
        this.form.name = this.$route.query.name
        this.$store.dispatch("getDict", 'question_type').then(res => {
            this.typeOptions = res.data
        });
        this.$store.dispatch("getPaperPreview", id).then(res => {
            this.form.introduction = res.data.introduction
            this.$refs['introductionEditor'].setContents(res.data.introduction)
            let question = res.data.test_paper_section_list
            for (let i = 0; i < question.length; i++) {
                const mId = question[i].id;
                this.$store.dispatch("getPaperModlePreview", {id, mId}).then(resData => {
                    question[i].question_list = resData.data.question_list
                    const list = question[i].question_list;
                    for (let n = 0; n < list.length; n++) {
                        let li = list[n];
                        let liScore = this.testPaperEditTextConfig.scoreTip.signMix(li.score)
                        if (!li.attachment) {
                            li.attachment = {}
                        }
                        let stem = li.stem
                        if (stem.indexOf('</p>') != -1) {
                            li.newStem = stem.slice(0, -4) + `<span class="el-tag el-tag--info el-tag--mini">${liScore}</span></p>`
                        } else {
                            li.newStem = stem + `<span class="el-tag el-tag--info el-tag--mini">${liScore}</span>`
                        }
                        if (question[i].question_type == 'subjectivity') {
                            li.answer_way = li.answer_way ? li.answer_way : this.answerWays[0].value
                            if (li.crosshead) {
                                for (let o = 0; o < li.crosshead.length; o++) {
                                    const f = li.crosshead[o]
                                    let fScore = this.testPaperEditTextConfig.scoreTip.signMix(f.score)
                                    let str = f.stem
                                    if (str.indexOf('</p>') != -1) {
                                        f.newStem = str.slice(0, -4) + `<span class="el-tag el-tag--info el-tag--mini">${fScore}</span></p>`
                                    } else {
                                        f.newStem = str + `<span class="el-tag el-tag--info el-tag--mini">${fScore}</span>`
                                    }
                                }
                            }
                            this.loadKey += 1
                        } else if (question[i].question_type == 'fill') {
                            li.newStem = li.newStem.replace(/\[\[(.*?)\]\]/g, '________________')
                        }
                    }
                });
            }
            this.question = question
            this.questionNum = res.data.question_num
            this.questionScore = res.data.total_score
            setTimeout(() => {
                this.loading = false
            }, 300);
        });
        this.$store.dispatch("getExamPaperAutoSave", id).then(res => {
            if (res.data) {
                let autoSave = this.testPaperEditTextConfig.autoSave
                this.$confirm(autoSave.message, autoSave.title, {
                    confirmButtonText: autoSave.ok,
                    cancelButtonText: autoSave.cancel,
                    type: 'warning',
                    dangerouslyUseHTMLString: true
                }).then(() => {
                    this.question = res.data.metas.test_paper_section_list
                    this.form.name = res.data.name
                    this.statisticsQuestion()
                    this.$message({
                        message: autoSave.success,
                        type: 'success'
                    });
                }).catch(() => {
                    this.recovery = true
                    this.temporaryPaper = res.data
                })
            }
        })
    }
}
</script>

<style scoped>
.info {
    color: #C0C4CC;
    font-size: 14px;
    line-height: 20px;
    margin-top: 6px;
}

.questionCon .right .box-card {
    height: calc(100% - 45px);
}

.questionCon .el-card__header .clearfix span:first-child, .questionCon .el-card__header .unClearfix span:first-child {
    font-weight: 600;
}

.questionCon .el-card__header .clearfix span:last-child, .questionCon .el-card__header .unClearfix span:last-child {
    font-size: 13px;
    display: inline-block;
    padding-top: 4px;
    margin-left: 20px;
}

.questionCon .el-card__header .clearfix span:last-child {
    float: right;
    margin-left: 0;
}

.questionCon .left .box-card .moduleButtonGroup {
    position: absolute;
    top: 14px;
    right: 20px;
    display: none;
}

.questionCon .left .box-card:hover .moduleButtonGroup {
    display: block;
}

.questionCon .left .box-card .questionButtonGroup {
    position: absolute;
    top: 14px;
    right: 20px;
    display: none;
}

.questionCon .left .box-card .questionModle:hover .questionButtonGroup {
    display: block;
}

.questionCon .right .box-card .questionButtons {
    height: calc(100% - 124px);
    width: 222px;
    overflow-y: auto;
}

.questionCon .right .box-card .questionButton {
    margin: 5px 10px 5px 0;
    width: 20%;
    display: inline-block;
    box-sizing: border-box;
}

.questionCheck:focus, .questionCheck:hover {
    border-color: #0070de;
    background-color: #fff;
    color: #0070de;
}

.questionCheck:focus span, .questionCheck:hover span {
    border-color: #c6e2ff;
}

.questionA {
    text-align: center;
    position: relative;
}

.questionA .check i {
    color: #fff;
    position: absolute;
    bottom: -20px;
    left: -13px;
}

.questionA:focus span, .questionA:hover span {
    border-color: #c6e2ff;
}

.questionCheck {
    border-color: #0070de;
}

.questionCheck .check {
    border: 0 solid transparent;
    width: 0;
    height: 0;
    border-bottom: 20px solid #0070de !important;
    border-left: 22px solid transparent !important;
    border-radius: 0;
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 1;
}

.questionModle {
    padding: 20px 20px 20px 45px;
    position: relative;
    margin-bottom: 10px;
    border: 1px solid #fff;
}

.questionModle:hover {
    border-color: #ebeef5;
    border-radius: 4px;
}

.questionModle > span {
    font-weight: 600;
    position: absolute;
    top: 25px;
    left: 18px;
}

.questionModle >>> .scoreTag {
    font-size: 13px !important;
    margin-left: 10px;
    line-height: 18px;
}

/* .questionModle .el-radio-group, .questionModle .el-checkbox-group {
    margin-top: 6px;
}
.questionModle .el-radio-group label {
    line-height: 16px !important;
    margin-top: 10px;
} */
.questionIndex {
    float: left;
    line-height: 32px;
}
</style>
